import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button, IconButton, Radio, RadioGroup, Stack, Text } from 'shell/components';

const FilterCourse = ({ sortKey, onClick, onClose, resetFilterSort }) => {
    const { t } = useTranslation();
    return (
        <Stack>
            <IconButton
                sx={{ alignSelf: 'flex-end' }}
                aria-label={'close'}
                kind={'exit'}
                size={'medium'}
                variant={'square'}
                onClick={onClose}
            />
            <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                    {t('controls.sort-by', 'Sort By')}
                </Text>
                <Button variant={'tertiary'} onClick={resetFilterSort}>
                    {t('controls.reset-all', 'Reset All')}
                </Button>
            </Stack>
            <Stack>
                <CustomRadioGroup
                    aria-label={'sort by'}
                    value={sortKey}
                    onChange={(_, value) => onClick('SORT', value)}
                >
                    <Radio
                        label={t('controls.sort-options.course-name-asc', 'Course Name A-Z')}
                        labelPlacement={'start'}
                        value={'titlea-z'}
                    />
                    <Radio
                        label={t('controls.sort-options.course-name-desc', 'Course Name Z-A')}
                        labelPlacement={'start'}
                        value={'titlez-a'}
                    />
                </CustomRadioGroup>
            </Stack>
        </Stack>
    );
};

const CustomRadioGroup = styled(RadioGroup)(() => {
    return {
        '& label': {
            justifyContent: 'space-between',
        },
    };
});

export default FilterCourse;
